import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoClip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideoClip"><Path d="M3.5 12H7.5M3.5 12V7.75M3.5 12V16.25M7.5 12H16.5M7.5 12V16.25M7.5 12V7.75M16.5 12H20.5M16.5 12V16.7222M16.5 12V7.75M20.5 12V7.75M20.5 12V16.7222M16.5 20.5H20.5V16.7222M16.5 20.5V16.7222M16.5 20.5H7.5M16.5 3.5H20.5V7.75M16.5 3.5V7.75M16.5 3.5H7.5M16.5 7.75H20.5M16.5 16.7222H20.5M7.5 20.5H3.5V16.25M7.5 20.5V16.25M7.5 3.5H3.5V7.75M7.5 3.5V7.75M3.5 7.75H7.5M3.5 16.25H7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVideoClip;
